/*
 * Jira Ticket:
 * Created Date: Tue, 17th Mar 2020, 14:11:47 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import edit from './edit';
import create from './create';
import icon from '@material-ui/icons/LocationOn';

export default {
  list, 
  create,
  edit,
  icon
};
